<template lang="pug">
  .NavigationDrawerMenuIcon.icon
    component(
      :is="getItemIcon()"
      :class="name"
    ).svg-icon.not-active
    component(
      :is="getItemActiveIcon()"
      :class="name"
    ).svg-icon.active-icon
</template>

<script>

import SolidDollarSignIcon from 'images/svg-icons/solid-dollar-sign.svg';
import SolidDollarSignGradientIcon from 'images/svg-icons/solid-dollar-sign-gradient.svg';
import SolidSeedlingIcon from 'images/svg-icons/solid-seedling.svg';
import SolidSeedlingGradientIcon from 'images/svg-icons/solid-seedling-gradient-green.svg';
import SolidBookIcon from 'images/svg-icons/solid-book.svg';
import SolidBookGradientIcon from 'images/svg-icons/solid-book-gradient.svg';
import ColorAcretraderIcon from 'images/svg-icons/acretrader-color.svg';
import TractorIcon from 'images/svg-icons/tractor.svg';
import TractorGradientIcon from 'images/svg-icons/tractor-gradient.svg';

export default {
  name: 'NavigationDrawerMenuIcon',
  components: {
    SolidDollarSignIcon,
    SolidDollarSignGradientIcon,
    SolidSeedlingIcon,
    SolidSeedlingGradientIcon,
    SolidBookIcon,
    SolidBookGradientIcon,
    ColorAcretraderIcon,
    TractorIcon,
    TractorGradientIcon,
  },
  props: {
    name: String,
  },
  methods: {
    getItemIcon() {
      switch (this.name) {
        case 'investors': {
          return SolidSeedlingIcon;
        }
        case 'explore': {
          return SolidDollarSignIcon;
        }
        case 'resources': {
          return SolidBookIcon;
        }
        case 'company': {
          return ColorAcretraderIcon;
        }
        case 'farm-owners': {
          return TractorIcon;
        }
        default: {
          return '';
        }
      }
    },
    getItemActiveIcon() {
      switch (this.name) {
        case 'investors': {
          return SolidSeedlingGradientIcon;
        }
        case 'explore': {
          return SolidDollarSignGradientIcon;
        }
        case 'resources': {
          return SolidBookGradientIcon;
        }
        case 'company': {
          return ColorAcretraderIcon;
        }
        case 'farm-owners': {
          return TractorGradientIcon;
        }
        default: {
          return '';
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.icon
  display: flex
  flex-direction: row
  height: 10px
  width: 10px
  align-items: center
  padding-top: 7px
  padding-bottom: 8px
  margin-right: 18px
  .svg-icon
    fill: $text_gray
    height: sizeInRem(10)
    width: sizeInRem(10)
</style>
